import { render, staticRenderFns } from "./PostSetupModalGroup.vue?vue&type=template&id=4607cbf4&scoped=true"
import script from "./PostSetupModalGroup.vue?vue&type=script&lang=js"
export * from "./PostSetupModalGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4607cbf4",
  null
  
)

export default component.exports